import { getExpiryStatus } from '../../utils/dateUtils';

export const StatusBadge = ({ date }) => {
  const { status, label } = getExpiryStatus(date);
  const cls = {
    valid: 'badge badge-green',
    soon: 'badge badge-yellow',
    warning: 'badge badge-orange',
    critical: 'badge badge-red',
    expired: 'badge badge-red',
    missing: 'badge badge-gray',
  }[status] || 'badge badge-gray';
  return <span className={cls}>{label}</span>;
};

export const Badge = ({ children, color = 'blue' }) => (
  <span className={`badge badge-${color}`}>{children}</span>
);
